import React from 'react';
import { Box, BoxProps } from '../../Box/Box';
import { Text } from '../../Text/Text';
import { ChartImg } from './img/ChartImg';
import { BoxImg } from './img/BoxImg';
import { NewspaperImg } from './img/NewspaperImg';

type EmptyStateVariant = 'box' | 'chart' | 'newspaper';

const ImageMap: Record<EmptyStateVariant, React.FC> = {
  box: BoxImg,
  chart: ChartImg,
  newspaper: NewspaperImg,
};

export interface EmptyStateProps extends BoxProps {
  message?: string;
  variant?: EmptyStateVariant;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message = 'No data to display',
  variant = 'box',
  ...rest
}) => {
  const Img = ImageMap[variant];

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      {...rest}
    >
      <Img />

      <Text fontSize="h4" fontWeight={600} textAlign="center" color="neutral.500" mt="16">
        {message}
      </Text>
    </Box>
  );
};
